module.exports = __webpack_public_path__ + "img/3-1-2.7848ec54.png";